export default "let one_day : int = 86_400\n// Type your solution below\nlet eta : timestamp = Tezos.now + 6 * one_day\n";